import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: {},
};

export const authSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    setTokenData: (state, action) => {
      state.token = action.payload;
    },
  },
});

export const { setTokenData } = authSlice.actions;

export default authSlice.reducer;
